module.exports = __webpack_public_path__ + "static/letters-from-a-stoic-d4b24304212c8572fd85333ce626be2b.jpg";